import { IRole } from "../../model/respone/user/IRole";
import { apiClient } from "../apiClient";
export const ROLE_API_RESOURCE = 'role';
export const ROLE_API_DELETE_RESOURCE = `${ROLE_API_RESOURCE}/{id}`;
export const roleApi = {
    insert: (payload: IRole) => apiClient.post(ROLE_API_RESOURCE, payload),
    update: (payload: IRole) => apiClient.put(ROLE_API_RESOURCE, payload),
    delete: (id: number) => apiClient.delete(`${ROLE_API_RESOURCE}/${id}`),
    getAll: () => apiClient.get(ROLE_API_RESOURCE),
    getSubSystem: (id: number) => apiClient.get(`${ROLE_API_RESOURCE}/${id}/sub-system`),
    getApis: (sub_system_id: number) => apiClient.get(`api/sub-system/${sub_system_id}`),
    getApisSelected: (role_id: number, sub_system_id: number) => apiClient.get(`${ROLE_API_RESOURCE}/${role_id}/sub-system/${sub_system_id}/api`),
    addApi: (role_id: number, api_id: number) => apiClient.post(`${ROLE_API_RESOURCE}/${role_id}/api/${api_id}`),
    removeApi: (role_id: number, api_id: number) => apiClient.delete(`${ROLE_API_RESOURCE}/${role_id}/api/${api_id}`),
    addSubsytem: (role_id: number, sub_system_id: number) => apiClient.post(`${ROLE_API_RESOURCE}/${role_id}/sub-system/${sub_system_id}`),
    removeSubsystem: (role_id: number, sub_system_id: number) => apiClient.delete(`${ROLE_API_RESOURCE}/${role_id}/sub-system/${sub_system_id}`),
}